// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebar {
    background-color: #F2F3FC;
    min-width: 200px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    padding: 30px 20px;
    max-height: 100%;
    overflow-y: scroll;
}

.sidebar_logo {
    max-width: 100%;
}

.sidebar_menu {
    display: flex;
    flex-direction: column;
    gap: 10px;
    width: 100%;
    height: 80vh;
}

.sidebar_item_link {
    text-decoration: none;
    color: inherit;
}

.sidebar_item {
    font-size: 16px;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 15px;
    max-width: 100%;
    padding: 12px 15px;
    border-radius: 10px;
    position: relative;
}

.sidebar_item_col {
    cursor: pointer;
    display: flex;
    flex-direction: column;
    align-items: start;
    max-width: 100%;
    padding: 12px 15px;
    border-radius: 10px;
    position: relative;
}

.sidebar_item_col:hover .sidebar_item_notselected{
    background-color: white;
}

.sidebar_item_link:hover .sidebar_item_notselected{
    background-color: white;
}

.sidebar_item_childtop {
    font-size: 16px;
    display: flex;
    gap: 15px;
    max-width: 100%;
}

.sidebar_item_childbottom {
    display: flex;
    flex-direction: column;
    max-width: 100%;
    margin-left: 20px;
    font-size: 14px;
    max-height: 0;
    overflow: hidden;
    transition: all 0.4s ease-in-out;
    gap: 15px;
}

.sidebar_item_childbottom-transition {
    margin-top: 20px;
    max-height: 500px;
}

.sidebar-info{
    width: 5px;
    height: 100%;
    position: absolute;
    left: 0px;
    top: 0px;
    border-radius: 5px;
}

.sidebar-subitem_info{
    width: 10px;
    height: 10px;
    position: absolute;
    left: 0px;
    top: 3px;
    border-radius: 5px;
}

.sidebar_item_selected {
    background-color: #2B64F5;
}

.sidebar_item_notselected{
    background-color: #F2F3FC;
}

.sidebar_subitem_selected {
    background-color: #2B64F5;
}

.sidebar_subitem_notselected{
    background-color: #F2F3FC;
}

.sidebar_subitem_notselected:hover{
    background-color: #FFF;
}

.sidebar_subitem_link{
    text-decoration: none;
    color: inherit;
    position: relative;
    padding-left: 20px;
}

.sidebar_item_selected .sidebar_item_name {
    font-weight: bold;
}

.sidebar_item_icon {
    width: 20px;
}

.sidebar_item_name {
    margin: 0;
}

.iconClose {
    transform: rotate(0);
}

.iconOpen {
    transform: rotate(180deg);
}

.sidebar_profil {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
}

.sidebar_profil_link {
    display: flex;
    align-items: center;
    text-decoration: none;
    color: inherit;
    gap: 10px;
}

.sidebar_profil_picture {
    width: 35px;
    height: 35px;
}

.sidebar_profil_img {
    width: 100%;
    height: 100%;
    border-radius: 100px;
}

.sidebar_profil_img_active{
    box-sizing: border-box;
    border: solid 3px black; 
    box-shadow: inset 0px 0px 0px 3px #2B64F5;
}

.sidebar_profil_infos {
    display: flex;
    flex-direction: column;
    gap: 0;
}

.sidebar_profil_name {
    margin: 0;
    font-size: 16px;
}

.sidebar_profil_role {
    margin: 0;
    font-size: 11px;
    color: #475467;
}

.sidebar_profil_logout{
    cursor: pointer;
}


@media (max-width: 768px) {
    .sidebar {
       display: none;
    }
}

@media (max-height: 900px) {
    .sidebar_menu {
       height: auto;
    }
    .sidebar {
        justify-content: flex-start;
        gap: 30px
    }
}`, "",{"version":3,"sources":["webpack://./src/components/menu/sidebar/sidebar.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,aAAa;IACb,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,iBAAiB;IACjB,eAAe;IACf,aAAa;IACb,gBAAgB;IAChB,gCAAgC;IAChC,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;IACd,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,oBAAoB;AACxB;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IAEvB,yCAAyC;AAC7C;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,MAAM;AACV;;AAEA;IACI,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;;AAGA;IACI;OACG,aAAa;IAChB;AACJ;;AAEA;IACI;OACG,YAAY;IACf;IACA;QACI,2BAA2B;QAC3B;IACJ;AACJ","sourcesContent":[".sidebar {\n    background-color: #F2F3FC;\n    min-width: 200px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: space-between;\n    padding: 30px 20px;\n    max-height: 100%;\n    overflow-y: scroll;\n}\n\n.sidebar_logo {\n    max-width: 100%;\n}\n\n.sidebar_menu {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    width: 100%;\n    height: 80vh;\n}\n\n.sidebar_item_link {\n    text-decoration: none;\n    color: inherit;\n}\n\n.sidebar_item {\n    font-size: 16px;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    gap: 15px;\n    max-width: 100%;\n    padding: 12px 15px;\n    border-radius: 10px;\n    position: relative;\n}\n\n.sidebar_item_col {\n    cursor: pointer;\n    display: flex;\n    flex-direction: column;\n    align-items: start;\n    max-width: 100%;\n    padding: 12px 15px;\n    border-radius: 10px;\n    position: relative;\n}\n\n.sidebar_item_col:hover .sidebar_item_notselected{\n    background-color: white;\n}\n\n.sidebar_item_link:hover .sidebar_item_notselected{\n    background-color: white;\n}\n\n.sidebar_item_childtop {\n    font-size: 16px;\n    display: flex;\n    gap: 15px;\n    max-width: 100%;\n}\n\n.sidebar_item_childbottom {\n    display: flex;\n    flex-direction: column;\n    max-width: 100%;\n    margin-left: 20px;\n    font-size: 14px;\n    max-height: 0;\n    overflow: hidden;\n    transition: all 0.4s ease-in-out;\n    gap: 15px;\n}\n\n.sidebar_item_childbottom-transition {\n    margin-top: 20px;\n    max-height: 500px;\n}\n\n.sidebar-info{\n    width: 5px;\n    height: 100%;\n    position: absolute;\n    left: 0px;\n    top: 0px;\n    border-radius: 5px;\n}\n\n.sidebar-subitem_info{\n    width: 10px;\n    height: 10px;\n    position: absolute;\n    left: 0px;\n    top: 3px;\n    border-radius: 5px;\n}\n\n.sidebar_item_selected {\n    background-color: #2B64F5;\n}\n\n.sidebar_item_notselected{\n    background-color: #F2F3FC;\n}\n\n.sidebar_subitem_selected {\n    background-color: #2B64F5;\n}\n\n.sidebar_subitem_notselected{\n    background-color: #F2F3FC;\n}\n\n.sidebar_subitem_notselected:hover{\n    background-color: #FFF;\n}\n\n.sidebar_subitem_link{\n    text-decoration: none;\n    color: inherit;\n    position: relative;\n    padding-left: 20px;\n}\n\n.sidebar_item_selected .sidebar_item_name {\n    font-weight: bold;\n}\n\n.sidebar_item_icon {\n    width: 20px;\n}\n\n.sidebar_item_name {\n    margin: 0;\n}\n\n.iconClose {\n    transform: rotate(0);\n}\n\n.iconOpen {\n    transform: rotate(180deg);\n}\n\n.sidebar_profil {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    width: 100%;\n}\n\n.sidebar_profil_link {\n    display: flex;\n    align-items: center;\n    text-decoration: none;\n    color: inherit;\n    gap: 10px;\n}\n\n.sidebar_profil_picture {\n    width: 35px;\n    height: 35px;\n}\n\n.sidebar_profil_img {\n    width: 100%;\n    height: 100%;\n    border-radius: 100px;\n}\n\n.sidebar_profil_img_active{\n    box-sizing: border-box;\n    border: solid 3px black;\n    -webkit-box-shadow: inset 0px 0px 0px 3px #2B64F5; \n    box-shadow: inset 0px 0px 0px 3px #2B64F5;\n}\n\n.sidebar_profil_infos {\n    display: flex;\n    flex-direction: column;\n    gap: 0;\n}\n\n.sidebar_profil_name {\n    margin: 0;\n    font-size: 16px;\n}\n\n.sidebar_profil_role {\n    margin: 0;\n    font-size: 11px;\n    color: #475467;\n}\n\n.sidebar_profil_logout{\n    cursor: pointer;\n}\n\n\n@media (max-width: 768px) {\n    .sidebar {\n       display: none;\n    }\n}\n\n@media (max-height: 900px) {\n    .sidebar_menu {\n       height: auto;\n    }\n    .sidebar {\n        justify-content: flex-start;\n        gap: 30px\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
